import BottomNav from "../components/BottomNav";
import { useNavigate } from "react-router-dom";
import "../css/FundsScreen.css";
import "../css/mainhome.css";
import { useEffect } from "react";
import { toast } from "react-toastify";
import AppHeader from "../components/AppHeader";
import apiClient from "../api/apiClient";

/* ✅ React Icons */
import { FaPlus, FaHistory, FaUniversity } from "react-icons/fa";
import { MdOutlinePendingActions, MdAccountBalanceWallet } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";

export default function FundsScreen() {
  const navigate = useNavigate();
  const walletBalance = localStorage.getItem("walletBalance");

  useEffect(() => {
    const fetchFeeSettings = async () => {
      try {
        const mobileNo = localStorage.getItem("mobileNo");

        const response = await apiClient.get("/fees-settings", {
          params: { mobileNo },
        });

        const { status, info } = response.data;
        if (status === true) {
          localStorage.setItem("feeSettings", JSON.stringify(info));
        }
      } catch (err) {
        console.error("Error fetching fee settings:", err);
      }
    };

    fetchFeeSettings();
  }, []);

  const handleWithdrawClick = () => {
    try {
      const settingsString = localStorage.getItem("feeSettings");
      if (!settingsString) {
        toast.error("Could not load settings. Please refresh.");
        return;
      }

      let settings = {};
      try {
        settings = JSON.parse(settingsString);
      } catch (e) {
        console.error("Failed to parse feeSettings:", e);
        toast.error("Settings corrupted. Please refresh.");
        return;
      }
      const { withdrawOpenTime, withdrawCloseTime, withdrawStatus } = settings;

      if (!withdrawStatus) {
        toast.warn("Withdrawals are temporarily disabled.");
        return;
      }

      const parseTimeString = (timeStr) => {
        const [time, meridian] = timeStr.split(" ");
        let [hours, minutes] = time.split(":").map(Number);
        if (meridian.toLowerCase() === "pm" && hours < 12) hours += 12;
        if (meridian.toLowerCase() === "am" && hours === 12) hours = 0;
        return { hours, minutes };
      };

      const now = new Date();
      const open = parseTimeString(withdrawOpenTime);
      const close = parseTimeString(withdrawCloseTime);

      const openTime = new Date();
      openTime.setHours(open.hours, open.minutes, 0, 0);

      const closeTime = new Date();
      closeTime.setHours(close.hours, close.minutes, 0, 0);

      if (now >= openTime && now <= closeTime) {
        navigate("/funds/withdraw");
      } else {
        toast.warn(
          `Withdrawal is only available from ${withdrawOpenTime} to ${withdrawCloseTime}.`
        );
      }
    } catch (error) {
      console.error("Error during withdrawal check:", error);
      toast.error("An unexpected error occurred.");
    }
  };

  /* ✅ ICONS UPDATED */
  const tiles = [
    {
      icon: <FaPlus />,
      title: "Add Funds",
      tone: "peach",
      onClick: () => navigate("/funds/add"),
    },
    {
      icon: <MdOutlinePendingActions />,
      title: "Manual Deposit Requests",
      tone: "peach2",
      onClick: () => navigate("/funds/depositHistory"),
    },
    {
      icon: <FaHistory />,
      title: "Withdraw History",
      tone: "lavender",
      onClick: () => navigate("/funds/WithdrawHistory"),
    },
    {
      icon: <FaUniversity />,
      title: "Add Bank Details",
      tone: "teal",
      onClick: () => navigate("/funds/addBankDetails"),
    },
    {
      icon: <GiTakeMyMoney />,
      title: "Withdraw Funds",
      tone: "blue",
      onClick: handleWithdrawClick,
    },
    {
      icon: <MdAccountBalanceWallet />,
      title: "Account Statement",
      tone: "green",
      onClick: () => navigate("/passbook"),
    },
  ];

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title="Funds"
        walletBalance={walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate("/passbook")}
      />

      <div className="funds-grid square">
        {tiles.map((t) => (
          <button
            key={t.title}
            className={`funds-tile tone-${t.tone}`}
            onClick={t.onClick}
          >
            <div className="tile-icon-wrap">
              {t.icon}
            </div>

            <div className="tile-title">{t.title}</div>
            <span className="tile-accent" />
          </button>
        ))}
      </div>

      <BottomNav active="Funds" />
    </div>
  );
}